
    <div class="gradient-separator"></div>
    <div class="content-panel">
        <div class="comment">
            <div class="text-subtitle"><strong>{{ 'GOAL_CUSTOM_GOALS.COMMENTS' | translate }}</strong></div>
            <app-comment-section [config]="createCommentConfig()" [comments]="reviewPeriodCustomGoal.customGoal?.comments" *ngIf="reviewPeriodCustomGoal.customGoal" 
                [isEditable]="false"
                [isShowDeleteButton]="false"
                [isAutoSave]="false"
                [singleComments]="true"
                [isCommentHeaderVisible]="true"
                displayStyle="style-3"
            ></app-comment-section>
        </div>
        <div class="action-button-panel">
            <button mat-flat-button color="primary" class="new-button" [disabled]="!allowComment()" (click)="onComment()" title="{{ 'GENERAL.EDIT_COMMENT_TITLE' | translate }}" [innerHTML]="'GENERAL.EDIT_COMMENT' | translate"></button>
        </div>
    </div>
